import React from 'react';
import { Link } from 'react-router-dom';

function ContactCTA({ icon = '✉️', title, description, emails = [], links = [] }) {
  return (
    <section className="rounded-3xl border border-primary/25 bg-gradient-to-br from-primary/15 to-transparent p-8 text-center md:p-10">
      <div className="mb-3 text-3xl">{icon}</div>
      <h2 className="mb-3 text-2xl font-black text-white">{title}</h2>
      <p className="mx-auto mb-6 max-w-xl text-silver leading-relaxed">{description}</p>
      <div className="flex flex-wrap justify-center gap-3">
        {emails.map(({ label, href }) => (
          <a key={href} href={href} className="btn-primary">
            {label}
          </a>
        ))}
        {links.map(({ label, to }) => (
          <Link key={to} to={to} className="btn-ghost">
            {label}
          </Link>
        ))}
      </div>
    </section>
  );
}

export default ContactCTA;
